module.exports = __webpack_public_path__ + "img/epk-photo-1.71dd5300.jpeg";